import { render, staticRenderFns } from "./AnchorIdManager.vue?vue&type=template&id=87ec24f8&scoped=true"
import script from "./AnchorIdManager.vue?vue&type=script&lang=js"
export * from "./AnchorIdManager.vue?vue&type=script&lang=js"
import style0 from "./AnchorIdManager.vue?vue&type=style&index=0&id=87ec24f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ec24f8",
  null
  
)

export default component.exports